module.exports = __webpack_public_path__ + "img/fcd1fd153a2be447379276718d45c8b9.ca145a66.png";